import { prepareAction } from '@/redux/helpers';
import { Action } from '@/redux/types';

import { ErrorsState, SET_ERROR } from './types';

export const setError = (data: ErrorsState): Action => prepareAction(SET_ERROR, data);
